import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  en: {
    translation: {
      nav: {
        home: 'Home',
        saved: 'Saved',
        facets: 'Advanced Filters',
        findByRequest: 'Find by Request',
        university: 'Near Universities',
        contact: 'Contact',
        language: 'Language',
        dataGrid: 'Data Grid',
      },
      hero: {
        title: 'Find Your Perfect',
        titleHighlight: 'Home',
        subtitle: 'Discover affordable housing, dormitories, and rental rooms across Vietnam',
        searchPlaceholder: 'Search by location, district...',
        searchButton: 'Search',
      },
      home: {
        heroBadge: 'Verified rental listings across Vietnam',
        quickTypes: 'Quick filters',
        exploreFacets: 'Advanced search with facets',
        viewDensity: 'Card layout',
        cardsPerRow: 'cards per row',
        stats: {
          properties: '500+ Properties',
          districts: '15+ Districts',
          universities: '50+ Universities',
        },
      },
      filter: {
        title: 'Filter Properties',
        location: 'Location',
        allLocations: 'All Locations',
        priceRange: 'Price Range',
        minPrice: 'Min Price',
        maxPrice: 'Max Price',
        type: 'Type',
        allTypes: 'All Types',
        anyTypes: 'Any',
        lessThan500k: '< 500,000₫',
        price1Mil: '1,000,000₫',
        price2Mil: '2,000,000₫',
        price3Mil: '3,000,000₫',
        price5Mil: '5,000,000₫',
        typeKyTucXa: 'Dormitory',
        typeSleepbox: 'Sleepbox',
        typeMiniduplex: 'Miniduplex',
        typePhong: 'Room (1 - 2 people)',
        reset: 'Reset Filters',
        apply: 'Apply Filters',
        basicSearch: 'Basic Search',
        advancedSearch: 'Advanced Search',
        showAdvanced: 'Advanced Search',
        hideAdvanced: 'Hide Advanced Search',
        showFilters: 'Show Filters',
        hideFilters: 'Hide Filters',
      },
      listing: {
        title: 'Available Properties',
        results: '{{count}} properties found',
        results_one: '{{count}} property found',
        resultsKyTucXa: '{{count}} dormitories found',
        resultsSleepbox: '{{count}} sleepboxes found',
        resultsMiniduplex: '{{count}} miniduplexes found',
        resultsPhong: '{{count}} rooms found',
        viewDetails: 'View Details',
        pricePerMonth: '₫/month',
        location: 'Location',
        noResults: 'No properties match your filters',
        noResultsHint: 'Try adjusting your search criteria',
        loadingMore: 'Loading more properties...',
        endOfList: 'You have reached the end of the list',
      },
      scrollTop: {
        label: 'Scroll to top',
      },
      detail: {
        overview: 'Overview',
        description: 'Description',
        amenities: 'Amenities',
        price: 'Price',
        location: 'Location',
        area: 'Area',
        contactInfo: 'Contact Information',
        phone: 'Phone',
        zalo: 'Zalo',
        email: 'Email',
        address: 'Address',
        nearby: 'Nearby Places',
        backToList: 'Back to Listings',
        contact: 'Call Now',
        shareProperty: 'Share',
        saveProperty: 'Save',
        status: 'Status',
        available: 'Available',
        unavailable: 'Unavailable',
        copied: 'Link copied to clipboard!',
        copiedPhone: 'Phone number copied!',
      },
      about: {
        title: 'Find by Request',
        subtitle: 'Tell us what you need, we will find the perfect place for you',
        missionTitle: 'How It Works?',
        missionDesc: 'Fill in the form below with your requirements. Our team will search for the best housing options that match your needs and contact you directly.',
        form: {
          title: 'Submit Your Request',
          name: 'Full Name',
          namePlaceholder: 'Enter your full name',
          phone: 'Phone Number',
          phonePlaceholder: 'Enter your phone number',
          propertyType: 'Property Type',
          propertyTypePlaceholder: 'Select property type',
          propertyTypeKyTucXa: 'Ký túc xá',
          propertyTypeSleepbox: 'Sleepbox',
          propertyTypeMiniduplex: 'Miniduplex',
          propertyTypePhong: 'Phòng (1 - 2 người)',
          district: 'Location (District)',
          districtPlaceholder: 'Select district',
          district1: 'District 1',
          district2: 'District 2',
          district3: 'District 3',
          district4: 'District 4',
          district5: 'District 5',
          district6: 'District 6',
          district7: 'District 7',
          district8: 'District 8',
          district9: 'District 9',
          district10: 'District 10',
          district11: 'District 11',
          district12: 'District 12',
          districtBinhThanh: 'Binh Thanh',
          districtThuDuc: 'Thu Duc',
          districtGoVap: 'Go Vap',
          districtTanBinh: 'Tan Binh',
          districtTanPhu: 'Tan Phu',
          districtPhuNhuan: 'Phu Nhuan',
          districtBinhChanh: 'Binh Chanh',
          districtCuChi: 'Cu Chi',
          districtHocMon: 'Hoc Mon',
          districtNhaBe: 'Nha Be',
          districtCanGio: 'Can Gio',
          amenities: 'Preferred Amenities',
          wifi: 'WiFi Available',
          parking: 'Parking',
          ac: 'Air Conditioner',
          fridge: 'Fridge',
          cooking: 'Cooking Area',
          balcony: 'Balcony',
          cleaning: 'In-house Cleaning Service',
          waterHeater: 'Water Heater',
          washingMachine: 'Washing Machine',
          elevator: 'Elevator',
          security: 'Security Camera',
          priceRange: 'Price Range',
          priceAny: 'Any price',
          lessThan500k: 'Dưới 500 nghìn',
          moveInDate: 'Planned Move-in Date',
          note: 'Note (Additional Details)',
          notePlaceholder: 'Any specific requirements...',
          submit: 'Submit Request',
          submitting: 'Submitting...',
          success: 'Your request has been submitted successfully! We will contact you soon.',
          successTitle: 'Request Submitted ✅',
          close: 'Close',
          error: 'Submission failed. Please try again.',
        },
        stats: {
          properties: '500+ Properties',
          cities: '10+ Cities',
          tenants: '10,000+ Happy Tenants',
          years: '5+ Years Experience',
        },
        featuresTitle: 'Why Choose Us?',
        features: {
          verified: {
            title: 'Verified Listings',
            desc: 'All properties are verified for accuracy and quality',
          },
          direct: {
            title: 'Direct Contact',
            desc: 'Connect directly with property owners, no agents needed',
          },
          transparent: {
            title: 'Transparent Pricing',
            desc: 'Clear pricing with no hidden fees or commissions',
          },
          support: {
            title: '24/7 Support',
            desc: 'Our team is always ready to help you find your home',
          },
        },
        teamTitle: 'Our Team',
        teamDesc: 'A passionate team dedicated to making housing accessible for everyone in Vietnam.',
      },
      common: {
        loading: 'Loading...',
        error: 'Something went wrong',
        retry: 'Try Again',
        close: 'Close',
        cancel: 'Cancel',
        copy: 'Copy',
        copied: 'Copied!',
        updating: 'Updating...',
        menu: 'Menu',
        vietnamese: 'Tiếng Việt',
        english: 'English',
        or: 'or',
      },
      footer: {
        rights: 'All rights reserved.',
        tagline: 'Find your perfect home in Vietnam.',
        quickLinks: 'Quick Links',
        contact: 'Contact Us',
        phone: 'Phone',
        email: 'Email',
        workingHours: 'Working Hours',
        workingHoursValue: 'Mon - Sun: 8:00 AM - 9:00 PM',
      },
      map: {
        title: 'Nearby Map',
        university: 'University',
        hospital: 'Hospital',
        market: 'Market',
        mall: 'Mall',
        property: 'Property',
        switchToGoogle: 'Google Maps',
        switchToOSM: 'OpenStreetMap',
        googleMapsError: 'Google Maps unavailable',
        googleMapsErrorHint: 'Configure REACT_APP_GOOGLE_MAPS_API_KEY to enable Google Maps',
        googleMapsPermissionError: 'Check API key restrictions in Google Cloud Console',
        googleMapsPermissionHint: 'Ensure Maps JavaScript API + Geocoding API are enabled and your domain is allowed in API key restrictions',
      },
      saved: {
        title: 'Saved Properties',
        count: '{{count}} property(ies) saved',
        empty: 'No saved properties yet',
        emptyHint: 'Tap the bookmark icon on any property card to save it here.',
        clearAll: 'Clear all saved',
        browseAll: 'Browse All Properties',
      },
      facets: {
        title: 'Advanced Filters',
        subtitle: 'Narrow down properties by district, type, price, and amenities',
        keyword: 'Keyword',
        availability: 'Availability',
        results: '{{count}} properties match your filters',
        price500k1m: '500,000₫ - 1,000,000₫',
        price1m2m: '1,000,000₫ - 2,000,000₫',
        price2m3m: '2,000,000₫ - 3,000,000₫',
        price3m5m: '3,000,000₫ - 5,000,000₫',
        priceGt5m: '> 5,000,000₫',
        perPage: 'Per page',
        prevPage: 'Prev',
        nextPage: 'Next',
        pageInfo: 'Page {{current}} of {{total}}',
      },
      sovereignty: {
        hoangSa: 'Hoàng Sa',
        truongSa: 'Trường Sa',
        paracelIslands: 'Paracel Islands',
        spratlyIslands: 'Spratly Islands',
      },
      nearMe: {
        title: 'Properties Near You',
        subtitle: 'Find the closest properties to your current location',
        button: 'Find Near Me',
        locating: 'Getting your location...',
        denied: 'Location access denied. Please enable location services or search manually above.',
        unavailable: 'Location unavailable. Please try again.',
        calculating: 'Finding nearby properties...',
        distance: '{{dist}} km away',
        found: 'Nearby properties found',
        noNearby: 'No properties found nearby. Try expanding your search.',
        yourLocation: 'Your Location',
        allowLocation: 'Allow location access to find properties near you',
      },
      university: {
        title: 'Find by University',
        subtitle: 'Discover rental properties near universities in Ho Chi Minh City',
        select: 'Select a University',
        placeholder: 'Choose a university...',
        propertiesFound: 'properties found',
        nearbyProperties: 'Nearby Properties',
        sortedByDistance: 'Sorted by distance',
        noProperties: 'No properties found within 5km of this university.',
        tryAnother: 'Try selecting a different university.',
        choosePrompt: 'Choose a University to Get Started',
        chooseDesc: 'Select a university from the dropdown above or click one of the quick options below to find rental properties within a 5km radius.',
        seeAll: 'Or use the dropdown to see all 50+ universities and colleges',
        university: 'University',
        property: 'Property',
        searchRadius: '5km search radius',
        fromUni: 'from university',
        viewDetail: 'View Details',
        geocoding: 'Geocoding property addresses... {{done}}/{{total}}',
        geocodingUni: 'Finding university location on map...',
        geocodeFailedUni: 'Could not determine the university location from its address.',
        loadingMap: 'Loading map...',
        filterType: 'Type',
        allTypes: 'All Types',
        sortBy: 'Sort by',
        sortDistance: 'Distance (Nearest)',
        sortPriceAsc: 'Price (Low to High)',
        sortPriceDesc: 'Price (High to Low)',
      },
      amenity: {
        wifi: 'Free WiFi',
        ac: 'Air Conditioning',
        waterHeater: 'Water Heater',
        parking: 'Parking',
        security: 'Security Camera',
        kitchen: 'Kitchen',
        laundry: 'Laundry',
        washingMachine: 'Washing machine',
        cooking: 'Cooking',
        elevator: 'Elevator',
        furniture: 'Furniture',
        fridge: 'Fridge',
        balcony: 'Balcony',
        cleaning: 'Housekeeping Service',
      },
      session: {
        pageTitle: 'Session Manager',
        pageSubtitle: 'Create and manage short-lived access links for public pages',
        createNew: 'New Session',
        createFormTitle: 'Create Access Session',
        label: 'Label',
        labelPlaceholder: 'e.g. Landlord - June 2026',
        ttl: 'Expires After',
        ttl30min: '30 minutes',
        ttl1hour: '1 hour',
        ttl3hours: '3 hours',
        ttl6hours: '6 hours',
        ttl12hours: '12 hours',
        ttl1day: '1 day',
        ttl3days: '3 days',
        ttl1week: '1 week',
        ttl1month: '1 month',
        generateLink: 'Generate Access Link',
        creating: 'Creating...',
        createdSuccess: 'Session created successfully!',
        sessionCreated: 'Session Created',
        accessUrl: 'Access URL',
        expiresAt: 'Expires at',
        noLabel: 'No label',
        loading: 'Loading sessions...',
        noSessions: 'No sessions yet',
        noSessionsHint: 'Create your first session to generate an access link.',
        created: 'Created',
        expires: 'Expires',
        timeRemaining: 'Remaining',
        status: 'Status',
        accessCount: 'Visits',
        actions: 'Actions',
        revoke: 'Revoke',
        revoked: 'Revoked',
        expired: 'Expired',
        active: 'Active',
        minutesRemaining: '{{count}} minutes',
        days: 'days',
        confirmRevoke: 'Are you sure you want to revoke this session? Users with this link will no longer be able to access the pages.',
        revokedSuccess: 'Session revoked successfully.',
        gateToggleTitle: 'Session Gate',
        gateEnabledDesc: 'Session gate is ON — visitors need a valid access link to view pages.',
        gateDisabledDesc: 'Session gate is OFF — anyone can access the site without authentication.',
        gateEnabledMsg: 'Session gate enabled. Public pages now require a valid access link.',
        gateDisabledMsg: 'Session gate disabled. Public pages are now open to everyone.',
        verifying: 'Verifying access...',
        noTokenTitle: 'Access Required',
        noTokenMessage: 'You need a valid access link to view this page.',
        accessDeniedTitle: 'Access Denied',
        accessDeniedMessage: 'Your access link is invalid or has expired.',
        expiredMessage: 'Your access link has expired. Please request a new one from the administrator.',
        contactAdmin: 'If you believe this is an error, please contact the administrator.',
        scopeSection: 'Access Scope',
        scopeAll: 'All Properties',
        scopeDistricts: 'Restrict by Districts',
        scopeProperties: 'Restrict by Properties',
        scopeSelectDistricts: 'Select districts to allow access to',
        scopeSelectProperties: 'Select properties to allow access to',
        scopeLoading: 'Loading available districts and properties...',
        scopeNoOptions: 'No options available',
        scopeSelected: '{{count}} selected',
        scopeType: 'Access Scope',
        scopeAllDesc: 'Access all properties (no restrictions)',
        scopeDistrictsDesc: 'Only show properties in selected districts',
        scopePropertiesDesc: 'Only show selected properties',
        scopeInfo: 'Scope: {{scope}}',
        scopeLabel_all: 'All properties',
        scopeLabel_districts: '{{count}} district(s)',
        scopeLabel_properties: '{{count}} property(ies)',
        scopeMixed: 'Mixed (Districts + Properties)',
        scopeMixedDesc: 'Select districts and/or specific properties',
        scopeSelectMixed: 'Select districts and properties to allow access to',
        scopeLabel_mixed: '{{count}} district(s), {{props}} property(ies)',
        landingProperty: 'Landing Property',
        landingDefaultLabel: '🏠 Homepage (default)',
        landingPropertyPlaceholder: 'Search for a property...',
        landingPropertyHint: 'Select a property to link directly to its detail page, or keep default to go to homepage.',
        renew: 'Renew',
        renewing: 'Renewing...',
        renewConfirm: 'Renew this session with a new {{ttl}} TTL? The session will be reactivated and its expiration reset.',
        renewSuccess: 'Session renewed successfully!',
        deleteSession: 'Delete',
        deleteConfirm: 'Are you sure you want to permanently delete this session? This cannot be undone.',
        deleteSuccess: 'Session permanently deleted.',
      },
      address: {
        title: 'Find by Address',
        subtitle: 'Search properties by address',
      },
      admin: {
        title: 'Create New Property',
        backToHome: '← Back to Home',
        loginGoogle: 'Sign in with Google',
        logout: 'Logout',
        loginTitle: 'Admin Access',
        propertyDetails: 'Property Details',
        titleVi: 'Title (VI) *',
        titleEn: 'Title (EN)',
        descriptionVi: 'Description (VI) *',
        descriptionEn: 'Description (EN)',
        addressVi: 'Address (VI) *',
        addressEn: 'Address (EN)',
        displayAddressVi: 'Display Address (VI) *',
        displayAddressEn: 'Display Address (EN)',
        additionalAddress1Vi: 'Additional Address 1 (VI)',
        additionalAddress1En: 'Additional Address 1 (EN)',
        additionalAddress2Vi: 'Additional Address 2 (VI)',
        additionalAddress2En: 'Additional Address 2 (EN)',
        cityVi: 'City (VI) *',
        cityEn: 'City (EN)',
        districtVi: 'District (VI) *',
        selectDistrict: 'Select District',
        price: 'Price (VND) *',
        pricePlaceholder: 'e.g., 5000000',
        propertyType: 'Property Type *',
        phone: 'Phone Number *',
        email: 'Email',
        available: 'Available for rent',
        shortTermLease: 'Short Term Lease',
        amenities: 'Amenities',
        nearbyVi: 'Nearby Places (VI)',
        nearbyPlaceholder: 'e.g., Chợ Bến Thành, Phố đi bộ Nguyễn Huệ',
        images: 'Property Images',
        imagesHelp: 'Select multiple images (jpg, png, webp)',
        secretInfo: 'Secret Info (Private)',
        secretInfoPlaceholder: 'Enter private information...',
        uploadSuccess: '{{count}} image(s) uploaded',
        create: 'Create Property',
        creating: 'Creating...',
        cancel: 'Cancel',
        progressTitle: 'Processing...',
        progressFolder: 'Creating district folder...',
        progressList: 'Checking property folders...',
        progressProperty: 'Creating property folder...',
        progressPropertyFile: 'Creating property.txt...',
        progressSecretFile: 'Creating secret.txt...',
        progressDeleteEncrypted: 'Removing old encrypted file...',
        progressCreateEncrypted: 'Creating new encrypted property.txt...',
        progressImages: 'Uploading images ({{count}})...',
        progressDone: 'Done!',
        errorNoToken: 'No access token available. Please authenticate with Google Drive first.',
        errorFailedToken: 'Failed to get access token. Please re-authenticate with Google Drive.',
        errorTokenError: 'Error getting access token: {{msg}}',
        errorNoConfig: 'Failed to load config',
        errorFolderId: 'Root folder ID not configured',
        errorDistrictRequired: 'District (VI) is required',
        errorTitleRequired: 'Title (VI) is required',
        errorCreateDistrict: 'Failed to create district folder',
        errorListProperty: 'Failed to list property folders',
        errorCreateProperty: 'Failed to create property folder',
        errorCreateFile: 'Failed to create property file',
        errorUploadImage: 'Failed to upload image: {{name}}',
        refreshToken: 'Refresh Token',
        refreshingToken: 'Refreshing...',
        tokenValid: 'Token valid',
        tokenExpired: 'Token expired',
        tokenRefreshSuccess: 'Token refreshed successfully',
        tokenRefreshFailed: 'Token refresh failed. Please re-authenticate.',
        successMsg: 'Property created successfully in folder: {{name}}',
        syncToD1: 'Sync Drive to D1',
        syncToD1Desc: 'Read all properties from Google Drive and store them in D1 database (replaces existing cache)',
        syncButton: 'Start Sync',
        syncing: 'Syncing...',
        syncSuccess: 'Successfully synced {{count}} properties from {{districts}} districts to D1',
        syncError: 'Sync failed: {{msg}}',
        syncProgress: 'Syncing properties to D1 database...',
        bulkUpdatePhone: 'Bulk Update Phone',
        bulkUpdateDesc: 'Update phone number for multiple properties at once',
        selectAll: 'Select All',
        deselectAll: 'Deselect All',
        selectedCount: '{{count}} selected',
        bulkPhonePlaceholder: 'Enter new phone number',
        bulkUpdateBtn: 'Update {{count}} properties',
        bulkUpdating: 'Updating...',
        bulkSuccess: 'Successfully updated phone number for {{count}} properties',
        bulkPartialSuccess: 'Updated {{success}} properties, {{failed}} failed',
        bulkError: 'Bulk update failed: {{msg}}',
        bulkPhoneLabel: 'New Phone Number',
      },
      calendar: {
        title: 'Property Viewing Calendar',
        subtitle: 'Manage property viewing appointments',
        day: 'Day',
        week: 'Week',
        month: 'Month',
        today: 'Today',
        events: 'events',
        newEvent: 'New Event',
        editEvent: 'Edit Event',
        userName: 'Visitor Name *',
        userNamePlaceholder: 'Enter visitor name',
        phone: 'Phone Number *',
        district: 'District *',
        selectDistrict: 'Select District',
        propertyName: 'Property Name *',
        propertyNamePlaceholder: 'Search property by name...',
        viewPropertyDetails: 'View Property Details',
        dateTime: 'Date & Time *',
        notes: 'Notes',
        notesPlaceholder: 'Additional information...',
        create: 'Create',
        update: 'Update',
        delete: 'Delete',
        cancel: 'Cancel',
        confirmDelete: 'Are you sure you want to delete this event?',
        revisitAction: 'Revisit & Reschedule',
        revisitNewDate: 'New Date & Time',
        revisitNote: '🔁 REVISIT — previous visit on {{date}} still not finalized, needs reconfirmation',
        revisitLabel: 'Revisit',
        finalizedAction: 'Mark as Done',
        finalizedLabel: 'Done',
        finalizedSubmitted: '✅ Successfully marked as completed',
        errorRequiredFields: 'Please fill in all required fields',
        mon: 'Mon',
        tue: 'Tue',
        wed: 'Wed',
        thu: 'Thu',
        fri: 'Fri',
        sat: 'Sat',
        sun: 'Sun',
      },
      userBooking: {
        title: 'Đặt lịch xem nhà',
        subtitle: 'Quản lý các đăng ký xem nhà từ khách hàng',
        total: 'Tổng số: {{count}} đăng ký',
        phoneFilter: 'Tìm kiếm theo số điện thoại',
        phonePlaceholder: 'Nhập số điện thoại để tìm kiếm...',
        sortBy: 'Sắp xếp theo ngày',
        newestFirst: 'Mới nhất trước',
        oldestFirst: 'Cũ nhất trước',
        addToCalendar: 'Thêm lịch',
        bookingDate: 'Ngày xem nhà',
        propertyName: 'Tên nhà trọ',
        registeredDate: 'Ngày đăng ký',
        actions: 'Thao tác',
        noData: 'Chưa có đăng ký xem nhà nào',
        noResults: 'Không tìm thấy kết quả với số điện thoại "{{phone}}"',
        loading: 'Đang tải dữ liệu...',
        error: 'Lỗi tải dữ liệu',
        retry: 'Thử lại',
        calendarOpened: 'Đã mở Google Calendar cho lịch hẹn của {{name}}',
        calendarError: 'Không thể tạo sự kiện lịch',
      },
      booking: {
        modalTitle: 'Đặt lịch xem nhà',
        name: 'Họ tên',
        namePlaceholder: 'Nhập họ tên của bạn',
        phone: 'Số điện thoại',
        phonePlaceholder: 'Nhập số điện thoại của bạn',
        visitingDate: 'Ngày xem nhà',
        note: 'Ghi chú',
        notePlaceholder: 'Ghi chú thêm (không bắt buộc)...',
        submit: 'Gửi đăng ký',
        submitting: 'Đang gửi...',
        successTitle: 'Đăng ký thành công!',
        success: 'Chúng tôi sẽ liên hệ với bạn để xác nhận lịch hẹn xem nhà.',
        close: 'Đóng',
        error: 'Không thể gửi thông tin. Vui lòng kiểm tra kết nối và thử lại.',
      },
      dashboard: {
        title: 'Dashboard',
        subtitle: 'System Overview Statistics',
        period: {
          day: 'Day',
          week: 'Week',
          month: 'Month',
          all: 'All',
        },
        visitingBookings: {
          title: 'Visiting Bookings',
          subtitle: 'Property viewing appointment statistics',
          new: 'New',
          newLabel: 'New bookings',
          newDesc: 'Newly created viewing appointments',
          pending: 'Pending',
          pendingLabel: 'Needs review',
          pendingDesc: 'Appointments needing review and confirmation',
          done: 'Done',
          doneLabel: 'Completed',
          doneDesc: 'Completed viewing appointments',
          total: 'Total appointments',
        },
        findByRequest: {
          title: 'Find by Request',
          subtitle: 'Number of find by request submissions',
          total: 'Total requests',
        },
        managedProperties: {
          title: 'Managed Properties',
          subtitle: 'Number of managed properties',
          total: 'Total properties',
          byDistrict: 'By District',
          district: 'District',
          count: 'Count',
        },
        refresh: 'Refresh',
        loading: 'Loading data...',
        error: 'Failed to load data',
        retry: 'Retry',
        noData: 'No data available',
        lastUpdated: 'Last updated',
        dataGrid: {
          title: 'Data Grid',
          subtitle: 'System data details',
          findByRequest: {
            title: 'Find by Request',
            total: 'Total requests',
          },
          visitingBookings: {
            title: 'Visiting Bookings',
            total: 'Bookings',
          },
          noData: 'No data available',
        },
      },
    },
  },
  vi: {
    translation: {
      nav: {
        home: 'Trang chủ',
        saved: 'Đã lưu',
        facets: 'Bộ lọc nâng cao',
        findByRequest: 'Tìm trọ theo yêu cầu',
        university: 'Gần Trường ĐH',
        contact: 'Liên hệ',
        language: 'Ngôn ngữ',
        dataGrid: 'Danh Sách Dữ Liệu',
      },
      hero: {
        title: 'Tìm Kiếm',
        titleHighlight: 'Nhà Trọ',
        subtitle: 'Khám phá nhà trọ, ký túc xá và phòng cho thuê giá rẻ trên khắp Việt Nam',
        searchPlaceholder: 'Tìm kiếm theo địa điểm, quận...',
        searchButton: 'Tìm kiếm',
      },
      home: {
        heroBadge: 'Niêm yết nhà trọ đã xác thực trên toàn quốc',
        quickTypes: 'Lọc nhanh',
        exploreFacets: 'Tìm kiếm nâng cao với bộ lọc',
        viewDensity: 'Kiểu hiển thị thẻ',
        cardsPerRow: 'thẻ mỗi hàng',
        stats: {
          properties: '500+ Phòng trọ',
          districts: '15+ Quận',
          universities: '50+ Trường ĐH',
        },
      },
      filter: {
        title: 'Bộ Lọc',
        location: 'Vị trí',
        allLocations: 'Tất cả',
        priceRange: 'Khoảng giá',
        minPrice: 'Giá tối thiểu',
        maxPrice: 'Giá tối đa',
        type: 'Loại',
        allTypes: 'Tất cả',
        anyTypes: 'Bất kỳ',
        lessThan500k: '< 500,000₫',
        price1Mil: '1,000,000₫',
        price2Mil: '2,000,000₫',
        price3Mil: '3,000,000₫',
        price5Mil: '5,000,000₫',
        typeKyTucXa: 'Ký túc xá',
        typeSleepbox: 'Sleepbox',
        typeMiniduplex: 'Miniduplex',
        typePhong: 'Phòng (1 - 2 người)',
        reset: 'Đặt lại',
        apply: 'Áp dụng',
        basicSearch: 'Tìm kiếm cơ bản',
        advancedSearch: 'Tìm kiếm nâng cao',
        showAdvanced: 'Mở rộng',
        hideAdvanced: 'Thu gọn',
        showFilters: 'Hiện bộ lọc',
        hideFilters: 'Ẩn bộ lọc',
      },
      listing: {
        title: 'Danh Sách Nhà Trọ',
        results: 'Tìm thấy {{count}} nhà trọ',
        results_one: 'Tìm thấy {{count}} nhà trọ',
        resultsNhaTro: 'Tìm thấy {{count}} nhà trọ',
        resultsKyTucXa: 'Tìm thấy {{count}} ký túc xá',
        resultsSleepbox: 'Tìm thấy {{count}} sleepbox',
        resultsMiniduplex: 'Tìm thấy {{count}} miniduplex',
        resultsPhong: 'Tìm thấy {{count}} phòng',
        viewDetails: 'Xem chi tiết',
        pricePerMonth: '₫/tháng',
        location: 'Vị trí',
        noResults: 'Không tìm thấy nhà trọ phù hợp',
        noResultsHint: 'Hãy thử điều chỉnh tiêu chí tìm kiếm',
        loadingMore: 'Đang tải thêm nhà trọ...',
        endOfList: 'Bạn đã xem hết danh sách',
      },
      scrollTop: {
        label: 'Cuộn lên đầu trang',
      },
      detail: {
        overview: 'Tổng quan',
        description: 'Mô tả',
        amenities: 'Tiện nghi',
        price: 'Giá',
        location: 'Vị trí',
        area: 'Diện tích',
        contactInfo: 'Thông tin liên hệ',
        phone: 'Điện thoại',
        zalo: 'Zalo',
        email: 'Email',
        address: 'Địa chỉ',
        nearby: 'Địa điểm lân cận',
        backToList: 'Quay lại danh sách',
        contact: 'Gọi Ngay',
        shareProperty: 'Chia sẻ',
        saveProperty: 'Lưu',
        status: 'Trạng thái',
        available: 'Còn trống',
        unavailable: 'Đã thuê',
        copied: 'Đã sao chép liên kết!',
        copiedPhone: 'Đã sao chép số điện thoại!',
      },
      about: {
        title: 'Tìm trọ theo yêu cầu',
        subtitle: 'Hãy cho chúng tôi biết nhu cầu của bạn, chúng tôi sẽ tìm nơi phù hợp nhất',
        missionTitle: 'Cách hoạt động?',
        missionDesc: 'Điền vào biểu mẫu bên dưới với nhu cầu của bạn. Đội ngũ của chúng tôi sẽ tìm kiếm các lựa chọn nhà trọ tốt nhất phù hợp với bạn và liên hệ trực tiếp.',
        form: {
          title: 'Gửi yêu cầu tìm trọ',
          name: 'Họ tên',
          namePlaceholder: 'Nhập họ tên của bạn',
          phone: 'Số điện thoại',
          phonePlaceholder: 'Nhập số điện thoại của bạn',
          propertyType: 'Loại nhà trọ',
          propertyTypePlaceholder: 'Chọn loại nhà trọ',
          propertyTypeKyTucXa: 'Ký túc xá',
          propertyTypeSleepbox: 'Sleepbox',
          propertyTypeMiniduplex: 'Miniduplex',
          propertyTypePhong: 'Phòng (1 - 2 người)',
          district: 'Địa điểm (Quận)',
          districtPlaceholder: 'Chọn quận',
          district1: 'Quận 1',
          district2: 'Quận 2',
          district3: 'Quận 3',
          district4: 'Quận 4',
          district5: 'Quận 5',
          district6: 'Quận 6',
          district7: 'Quận 7',
          district8: 'Quận 8',
          district9: 'Quận 9',
          district10: 'Quận 10',
          district11: 'Quận 11',
          district12: 'Quận 12',
          districtBinhThanh: 'Bình Thạnh',
          districtThuDuc: 'Thủ Đức',
          districtGoVap: 'Gò Vấp',
          districtTanBinh: 'Tân Bình',
          districtTanPhu: 'Tân Phú',
          districtPhuNhuan: 'Phú Nhuận',
          districtBinhChanh: 'Bình Chánh',
          districtCuChi: 'Củ Chi',
          districtHocMon: 'Hóc Môn',
          districtNhaBe: 'Nhà Bè',
          districtCanGio: 'Cần Giờ',
          amenities: 'Tiện ích mong muốn',
          wifi: 'Có WiFi',
          parking: 'Chỗ để xe',
          ac: 'Máy lạnh',
          fridge: 'Tủ lạnh',
          cooking: 'Khu vực bếp',
          balcony: 'Ban công',
          cleaning: 'Dịch vụ dọn phòng',
          waterHeater: 'Máy nước nóng',
          washingMachine: 'Máy giặt',
          elevator: 'Thang máy',
          security: 'Camera an ninh',
          priceRange: 'Khoảng giá',
          priceAny: 'Bất kỳ',
          lessThan500k: 'Dưới 500 nghìn',
          moveInDate: 'Ngày dự kiến đến',
          note: 'Ghi chú (chi tiết thêm)',
          notePlaceholder: 'Các yêu cầu đặc biệt khác...',
          submit: 'Gửi yêu cầu',
          submitting: 'Đang gửi...',
          success: 'Yêu cầu của bạn đã được gửi thành công! Chúng tôi sẽ liên hệ với bạn sớm.',
          successTitle: 'Đã gửi yêu cầu ✅',
          close: 'Đóng',
          error: 'Gửi yêu cầu thất bại. Vui lòng thử lại.',
        },
        stats: {
          properties: '500+ Phòng trọ',
          cities: '10+ Thành phố',
          tenants: '10,000+ Khách hàng',
          years: '5+ Năm kinh nghiệm',
        },
        featuresTitle: 'Tại sao chọn chúng tôi?',
        features: {
          verified: {
            title: 'Niêm yết đã xác thực',
            desc: 'Tất cả nhà trọ đều được kiểm tra về độ chính xác và chất lượng',
          },
          direct: {
            title: 'Liên hệ trực tiếp',
            desc: 'Kết nối trực tiếp với chủ nhà, không qua môi giới',
          },
          transparent: {
            title: 'Giá minh bạch',
            desc: 'Giá rõ ràng, không phí ẩn hoặc hoa hồng',
          },
          support: {
            title: 'Hỗ trợ 24/7',
            desc: 'Đội ngũ luôn sẵn sàng giúp bạn tìm nhà',
          },
        },
        teamTitle: 'Đội ngũ của chúng tôi',
        teamDesc: 'Một đội ngũ tận tâm với sứ mệnh giúp mọi người dễ dàng tìm được nhà ở tại Việt Nam.',
      },
      common: {
        loading: 'Đang tải...',
        error: 'Đã xảy ra lỗi',
        retry: 'Thử lại',
        close: 'Đóng',
        cancel: 'Hủy',
        copy: 'Sao chép',
        copied: 'Đã sao chép!',
        updating: 'Đang cập nhật...',
        menu: 'Menu',
        vietnamese: 'Tiếng Việt',
        english: 'English',
        or: 'hoặc',
      },
      footer: {
        rights: 'Đã đăng ký bản quyền.',
        tagline: 'Tìm nhà trọ phù hợp tại Việt Nam.',
        quickLinks: 'Liên kết nhanh',
        contact: 'Liên hệ',
        phone: 'Điện thoại',
        email: 'Email',
        workingHours: 'Giờ làm việc',
        workingHoursValue: 'T2 - CN: 8:00 - 21:00',
      },
      map: {
        title: 'Bản đồ khu vực',
        university: 'Trường đại học',
        hospital: 'Bệnh viện',
        market: 'Chợ',
        mall: 'Trung tâm thương mại',
        property: 'Phòng trọ',
        switchToGoogle: 'Google Maps',
        switchToOSM: 'OpenStreetMap',
        googleMapsError: 'Google Maps không khả dụng',
        googleMapsErrorHint: 'Cấu hình REACT_APP_GOOGLE_MAPS_API_KEY để sử dụng Google Maps',
        googleMapsPermissionError: 'Kiểm tra restrictions của API key trên Google Cloud Console',
        googleMapsPermissionHint: 'Đảm bảo Maps JavaScript API + Geocoding API được bật và domain của bạn được cho phép',
      },
      saved: {
        title: 'Nhà Trọ Đã Lưu',
        count: 'Đã lưu {{count}} nhà trọ',
        empty: 'Chưa có nhà trọ nào được lưu',
        emptyHint: 'Nhấn vào biểu tượng đánh dấu trên thẻ nhà trọ để lưu vào đây.',
        clearAll: 'Xoá tất cả',
        browseAll: 'Xem tất cả nhà trọ',
      },
      facets: {
        title: 'Bộ Lọc Nâng Cao',
        subtitle: 'Lọc nhà trọ theo quận, loại, khoảng giá và tiện ích',
        keyword: 'Từ khoá',
        availability: 'Tình trạng',
        results: '{{count}} nhà trọ phù hợp bộ lọc',
        price500k1m: '500,000₫ - 1,000,000₫',
        price1m2m: '1,000,000₫ - 2,000,000₫',
        price2m3m: '2,000,000₫ - 3,000,000₫',
        price3m5m: '3,000,000₫ - 5,000,000₫',
        priceGt5m: '> 5,000,000₫',
        perPage: 'Mỗi trang',
        prevPage: 'Trước',
        nextPage: 'Sau',
        pageInfo: 'Trang {{current}}/{{total}}',
      },
      sovereignty: {
        hoangSa: 'Hoàng Sa',
        truongSa: 'Trường Sa',
        paracelIslands: 'Quần đảo Hoàng Sa',
        spratlyIslands: 'Quần đảo Trường Sa',
      },
      nearMe: {
        title: 'Nhà Trọ Gần Bạn',
        subtitle: 'Tìm nhà trọ gần vị trí hiện tại của bạn nhất',
        button: 'Tìm Gần Đây',
        locating: 'Đang lấy vị trí của bạn...',
        denied: 'Quyền truy cập vị trí bị từ chối. Vui lòng bật dịch vụ định vị hoặc tìm kiếm thủ công ở trên.',
        unavailable: 'Không thể lấy vị trí. Vui lòng thử lại.',
        calculating: 'Đang tìm nhà trọ gần đây...',
        distance: 'Cách {{dist}} km',
        found: 'Đã tìm thấy nhà trọ gần bạn',
        noNearby: 'Không tìm thấy nhà trọ nào gần đây. Hãy thử mở rộng tìm kiếm.',
        yourLocation: 'Vị trí của bạn',
        allowLocation: 'Cho phép truy cập vị trí để tìm nhà trọ gần bạn',
      },
      university: {
        title: 'Tìm Theo Trường Đại Học',
        subtitle: 'Khám phá nhà trọ gần các trường đại học tại TP.HCM',
        select: 'Chọn Trường Đại Học',
        placeholder: 'Chọn một trường...',
        propertiesFound: 'phòng trọ',
        nearbyProperties: 'Phòng Trọ Gần Trường',
        sortedByDistance: 'Sắp xếp theo khoảng cách',
        noProperties: 'Không tìm thấy phòng trọ nào trong bán kính 5km.',
        tryAnother: 'Hãy thử chọn một trường khác.',
        choosePrompt: 'Chọn Trường Đại Học',
        chooseDesc: 'Chọn một trường từ danh sách hoặc nhấn vào trường bên dưới để tìm phòng trọ trong bán kính 5km.',
        seeAll: 'Hoặc dùng dropdown để xem tất cả 50+ trường Đại học & Cao đẳng',
        university: 'Trường đại học',
        property: 'Phòng trọ',
        searchRadius: 'Bán kính 5km',
        fromUni: 'từ trường',
        viewDetail: 'Xem chi tiết',
        geocoding: 'Đang lấy tọa độ nhà trọ... {{done}}/{{total}}',
        geocodingUni: 'Đang xác định vị trí trường trên bản đồ...',
        geocodeFailedUni: 'Không thể xác định vị trí trường từ địa chỉ đã cho.',
        loadingMap: 'Đang tải bản đồ...',
        filterType: 'Loại phòng',
        allTypes: 'Tất cả',
        sortBy: 'Sắp xếp',
        sortDistance: 'Khoảng cách (Gần nhất)',
        sortPriceAsc: 'Giá (Thấp đến Cao)',
        sortPriceDesc: 'Giá (Cao đến Thấp)',
      },
      amenity: {
        wifi: 'WiFi miễn phí',
        ac: 'Máy lạnh',
        waterHeater: 'Máy nước nóng',
        parking: 'Chỗ để xe',
        security: 'Camera an ninh',
        kitchen: 'Phòng bếp',
        laundry: 'Giặt ủi',
        washingMachine: 'Máy giặt',
        cooking: 'Phòng bếp',
        elevator: 'Thang máy',
        furniture: 'Nội thất',
        fridge: 'Tủ lạnh',
        balcony: 'Ban công',
        cleaning: 'Dịch vụ dọn phòng',
      },
      session: {
        pageTitle: 'Quản Lý Truy Cập',
        pageSubtitle: 'Tạo và quản lý các đường dẫn truy cập có thời hạn cho trang công khai',
        createNew: 'Tạo mới',
        createFormTitle: 'Tạo phiên truy cập',
        label: 'Nhãn',
        labelPlaceholder: 'VD: Chủ nhà A - Tháng 6/2026',
        ttl: 'Thời hạn',
        ttl30min: '30 phút',
        ttl1hour: '1 giờ',
        ttl3hours: '3 giờ',
        ttl6hours: '6 giờ',
        ttl12hours: '12 giờ',
        ttl1day: '1 ngày',
        ttl3days: '3 ngày',
        ttl1week: '1 tuần',
        ttl1month: '1 tháng',
        generateLink: 'Tạo đường dẫn',
        creating: 'Đang tạo...',
        createdSuccess: 'Đã tạo phiên truy cập thành công!',
        sessionCreated: 'Đã tạo phiên truy cập',
        accessUrl: 'Đường dẫn truy cập',
        expiresAt: 'Hết hạn lúc',
        noLabel: 'Không có nhãn',
        loading: 'Đang tải danh sách...',
        noSessions: 'Chưa có phiên truy cập nào',
        noSessionsHint: 'Tạo phiên truy cập đầu tiên để sinh đường dẫn.',
        created: 'Đã tạo',
        expires: 'Hết hạn',
        timeRemaining: 'Còn lại',
        status: 'Trạng thái',
        accessCount: 'Lượt truy cập',
        actions: 'Thao tác',
        revoke: 'Thu hồi',
        revoked: 'Đã thu hồi',
        expired: 'Hết hạn',
        active: 'Hoạt động',
        minutesRemaining: '{{count}} phút',
        days: 'ngày',
        confirmRevoke: 'Bạn có chắc chắn muốn thu hồi phiên truy cập này? Người dùng có đường dẫn này sẽ không thể truy cập được nữa.',
        revokedSuccess: 'Đã thu hồi phiên truy cập thành công.',
        gateToggleTitle: 'Cổng Truy Cập',
        gateEnabledDesc: 'Cổng truy cập đang BẬT — khách cần đường dẫn hợp lệ để xem trang.',
        gateDisabledDesc: 'Cổng truy cập đang TẮT — mọi người đều có thể truy cập mà không cần xác thực.',
        gateEnabledMsg: 'Đã bật cổng truy cập. Trang công khai yêu cầu đường dẫn hợp lệ.',
        gateDisabledMsg: 'Đã tắt cổng truy cập. Trang công khai mở cho tất cả mọi người.',
        verifying: 'Đang xác thực truy cập...',
        noTokenTitle: 'Yêu cầu truy cập',
        noTokenMessage: 'Bạn cần một đường dẫn truy cập hợp lệ để xem trang này.',
        accessDeniedTitle: 'Từ chối truy cập',
        accessDeniedMessage: 'Đường dẫn truy cập của bạn không hợp lệ hoặc đã hết hạn.',
        expiredMessage: 'Đường dẫn truy cập của bạn đã hết hạn. Vui lòng yêu cầu quản trị viên cấp đường dẫn mới.',
        contactAdmin: 'Nếu bạn cho rằng đây là lỗi, vui lòng liên hệ quản trị viên.',
        scopeSection: 'Phạm vi truy cập',
        scopeAll: 'Tất cả nhà trọ',
        scopeDistricts: 'Giới hạn theo quận',
        scopeProperties: 'Giới hạn theo nhà trọ',
        scopeSelectDistricts: 'Chọn các quận được phép truy cập',
        scopeSelectProperties: 'Chọn các nhà trọ được phép truy cập',
        scopeLoading: 'Đang tải danh sách quận và nhà trọ...',
        scopeNoOptions: 'Không có lựa chọn nào',
        scopeSelected: 'Đã chọn {{count}}',
        scopeType: 'Phạm vi truy cập',
        scopeAllDesc: 'Truy cập tất cả nhà trọ (không giới hạn)',
        scopeDistrictsDesc: 'Chỉ hiển thị nhà trọ trong các quận đã chọn',
        scopePropertiesDesc: 'Chỉ hiển thị các nhà trọ đã chọn',
        scopeInfo: 'Phạm vi: {{scope}}',
        scopeLabel_all: 'Tất cả nhà trọ',
        scopeLabel_districts: '{{count}} quận',
        scopeLabel_properties: '{{count}} nhà trọ',
        scopeMixed: 'Kết hợp (Quận + Nhà trọ)',
        scopeMixedDesc: 'Chọn quận và/hoặc nhà trọ cụ thể',
        scopeSelectMixed: 'Chọn quận và nhà trọ được phép truy cập',
        scopeLabel_mixed: '{{count}} quận, {{props}} nhà trọ',
        landingProperty: 'Nhà trọ đích',
        landingDefaultLabel: '🏠 Trang chủ (mặc định)',
        landingPropertyPlaceholder: 'Tìm kiếm nhà trọ...',
        landingPropertyHint: 'Chọn nhà trọ để tạo link đến trang chi tiết, hoặc để mặc định đến trang chủ.',
        renew: 'Gia hạn',
        renewing: 'Đang gia hạn...',
        renewConfirm: 'Gia hạn phiên này với TTL {{ttl}} mới? Phiên sẽ được kích hoạt lại và đặt lại thời gian hết hạn.',
        renewSuccess: 'Đã gia hạn phiên truy cập thành công!',
        deleteSession: 'Xoá',
        deleteConfirm: 'Bạn có chắc chắn muốn xoá vĩnh viễn phiên truy cập này? Hành động này không thể hoàn tác.',
        deleteSuccess: 'Đã xoá phiên truy cập vĩnh viễn.',
      },
      address: {
        title: 'Tìm theo địa chỉ',
        subtitle: 'Tìm kiếm nhà trọ theo địa chỉ',
      },
      admin: {
        title: 'Tạo phòng trọ',
        backToHome: '← Quay lại',
        loginGoogle: 'Đăng nhập bằng Google',
        logout: 'Đăng xuất',
        loginTitle: 'Truy cập Admin',
        propertyDetails: 'Thông tin phòng trọ',
        titleVi: 'Tiêu đề (VI) *',
        titleEn: 'Tiêu đề (EN)',
        descriptionVi: 'Mô tả (VI) *',
        descriptionEn: 'Mô tả (EN)',
        addressVi: 'Địa chỉ (VI) *',
        addressEn: 'Địa chỉ (EN)',
        displayAddressVi: 'Địa chỉ hiển thị (VI) *',
        displayAddressEn: 'Địa chỉ hiển thị (EN)',
        additionalAddress1Vi: 'Địa chỉ bổ sung 1 (VI)',
        additionalAddress1En: 'Địa chỉ bổ sung 1 (EN)',
        additionalAddress2Vi: 'Địa chỉ bổ sung 2 (VI)',
        additionalAddress2En: 'Địa chỉ bổ sung 2 (EN)',
        cityVi: 'Thành phố (VI) *',
        cityEn: 'Thành phố (EN)',
        districtVi: 'Quận (VI) *',
        selectDistrict: 'Chọn Quận',
        price: 'Giá (VND) *',
        pricePlaceholder: 'ví dụ: 5000000',
        propertyType: 'Loại phòng *',
        phone: 'Số điện thoại *',
        email: 'Email',
        available: 'Còn trống',
        shortTermLease: 'Cho thuê ngắn ngày',
        amenities: 'Tiện nghi',
        nearbyVi: 'Địa điểm lân cận (VI)',
        nearbyPlaceholder: 'ví dụ: Chợ Bến Thành, Phố đi bộ Nguyễn Huệ',
        images: 'Hình ảnh phòng trọ',
        imagesHelp: 'Chọn nhiều ảnh (jpg, png, webp)',
        secretInfo: 'Thông tin bí mật (Riêng tư)',
        secretInfoPlaceholder: 'Nhập thông tin riêng tư...',
        uploadSuccess: 'Đã tải lên {{count}} ảnh',
        create: 'Tạo phòng trọ',
        creating: 'Đang tạo...',
        cancel: 'Hủy',
        progressTitle: 'Đang xử lý...',
        progressFolder: 'Đang tạo thư mục quận...',
        progressList: 'Đang kiểm tra thư mục phòng...',
        progressProperty: 'Đang tạo thư mục phòng...',
        progressPropertyFile: 'Đang tạo property.txt...',
        progressSecretFile: 'Đang tạo secret.txt...',
        progressDeleteEncrypted: 'Đang xoá file mã hoá cũ...',
        progressCreateEncrypted: 'Đang tạo file mã hoá mới...',
        progressImages: 'Đang tải ảnh lên ({{count}})...',
        progressDone: 'Hoàn tất!',
        errorNoToken: 'Không tìm thấy mã token. Vui lòng xác thực với Google Drive trước.',
        errorFailedToken: 'Lấy mã token thất bại. Vui lòng xác thực lại với Google Drive.',
        errorTokenError: 'Lỗi lấy mã token: {{msg}}',
        errorNoConfig: 'Không thể tải cấu hình',
        errorFolderId: 'Root folder ID chưa được cấu hình',
        errorDistrictRequired: 'Vui lòng chọn Quận',
        errorTitleRequired: 'Vui lòng nhập Tiêu đề',
        errorCreateDistrict: 'Không thể tạo thư mục quận',
        errorListProperty: 'Không thể lấy danh sách thư mục phòng trọ',
        errorCreateProperty: 'Không thể tạo thư mục phòng trọ',
        errorCreateFile: 'Không thể tạo file property.txt',
        errorUploadImage: 'Không thể tải ảnh lên: {{name}}',
        refreshToken: 'Làm mới Token',
        refreshingToken: 'Đang làm mới...',
        tokenValid: 'Token hợp lệ',
        tokenExpired: 'Token hết hạn',
        tokenRefreshSuccess: 'Token đã được làm mới thành công',
        tokenRefreshFailed: 'Làm mới token thất bại. Vui lòng xác thực lại.',
        successMsg: 'Đã tạo phòng trọ thành công trong thư mục: {{name}}',
        syncToD1: 'Đồng bộ Drive vào D1',
        syncToD1Desc: 'Đọc tất cả phòng trọ từ Google Drive và lưu vào cơ sở dữ liệu D1 (thay thế bộ nhớ đệm hiện tại)',
        syncButton: 'Bắt đầu đồng bộ',
        syncing: 'Đang đồng bộ...',
        syncSuccess: 'Đã đồng bộ thành công {{count}} phòng trọ từ {{districts}} quận vào D1',
        syncError: 'Đồng bộ thất bại: {{msg}}',
        syncProgress: 'Đang đồng bộ phòng trọ vào cơ sở dữ liệu D1...',
        bulkUpdatePhone: 'Cập nhật số điện thoại hàng loạt',
        bulkUpdateDesc: 'Cập nhật số điện thoại cho nhiều phòng trọ cùng lúc',
        selectAll: 'Chọn tất cả',
        deselectAll: 'Bỏ chọn tất cả',
        selectedCount: 'Đã chọn {{count}}',
        bulkPhonePlaceholder: 'Nhập số điện thoại mới',
        bulkUpdateBtn: 'Cập nhật {{count}} phòng trọ',
        bulkUpdating: 'Đang cập nhật...',
        bulkSuccess: 'Đã cập nhật số điện thoại thành công cho {{count}} phòng trọ',
        bulkPartialSuccess: 'Đã cập nhật {{success}} phòng trọ, {{failed}} thất bại',
        bulkError: 'Cập nhật hàng loạt thất bại: {{msg}}',
        bulkPhoneLabel: 'Số điện thoại mới',
      },
      calendar: {
        title: 'Lịch Xem Nhà',
        subtitle: 'Quản lý lịch hẹn xem phòng trọ',
        day: 'Ngày',
        week: 'Tuần',
        month: 'Tháng',
        today: 'Hôm nay',
        events: 'sự kiện',
        newEvent: 'Sự kiện mới',
        editEvent: 'Sửa sự kiện',
        userName: 'Tên người xem *',
        userNamePlaceholder: 'Nhập tên người xem',
        phone: 'Số điện thoại *',
        district: 'Quận *',
        selectDistrict: 'Chọn Quận',
        propertyName: 'Tên phòng trọ *',
        propertyNamePlaceholder: 'Tìm kiếm phòng trọ theo tên...',
        viewPropertyDetails: 'Xem chi tiết phòng trọ',
        dateTime: 'Ngày & Giờ *',
        notes: 'Ghi chú',
        notesPlaceholder: 'Thông tin bổ sung...',
        create: 'Tạo',
        update: 'Cập nhật',
        delete: 'Xóa',
        cancel: 'Hủy',
        confirmDelete: 'Bạn có chắc chắn muốn xóa sự kiện này?',
        revisitAction: 'Xem lại & Đặt lịch mới',
        revisitNewDate: 'Ngày & Giờ mới',
        revisitNote: '🔁 XEM LẠI — lần trước vào {{date}} chưa chốt được, cần xác nhận lại',
        revisitLabel: 'Xem lại',
        finalizedAction: 'Đã hoàn tất',
        finalizedLabel: 'Hoàn tất',
        finalizedSubmitted: 'Xác nhận hoàn tất với sự kiện này?',
        errorRequiredFields: 'Vui lòng điền đầy đủ các trường bắt buộc',
        mon: 'T2',
        tue: 'T3',
        wed: 'T4',
        thu: 'T5',
        fri: 'T6',
        sat: 'T7',
        sun: 'CN',
      },
      dashboard: {
        title: 'Bảng Điều Khiển',
        subtitle: 'Thống kê tổng quan hệ thống',
        period: {
          day: 'Ngày',
          week: 'Tuần',
          month: 'Tháng',
          all: 'Tất cả',
        },
        visitingBookings: {
          title: 'Lịch Xem Nhà',
          subtitle: 'Thống kê lịch hẹn xem phòng trọ',
          new: 'Mới',
          newLabel: 'Lịch hẹn mới',
          newDesc: 'Lịch xem nhà mới tạo',
          pending: 'Chờ xử lý',
          pendingLabel: 'Cần xem lại',
          pendingDesc: 'Lịch cần xem lại và xác nhận',
          done: 'Hoàn thành',
          doneLabel: 'Đã hoàn thành',
          doneDesc: 'Lịch xem nhà đã kết thúc',
          total: 'Tổng lịch hẹn',
        },
        findByRequest: {
          title: 'Yêu Cầu Tìm Trọ',
          subtitle: 'Số lượng yêu cầu tìm trọ theo yêu cầu',
          total: 'Tổng yêu cầu',
        },
        managedProperties: {
          title: 'Nhà Trọ Quản Lý',
          subtitle: 'Số lượng nhà trọ đang quản lý',
          total: 'Tổng nhà trọ',
          byDistrict: 'Phân bố theo quận',
          district: 'Quận',
          count: 'Số lượng',
        },
        refresh: 'Làm mới',
        loading: 'Đang tải dữ liệu...',
        error: 'Không thể tải dữ liệu',
        retry: 'Thử lại',
        noData: 'Chưa có dữ liệu',
        lastUpdated: 'Cập nhật lần cuối',
        dataGrid: {
          title: 'Danh Sách Dữ Liệu',
          subtitle: 'Chi tiết dữ liệu hệ thống',
          findByRequest: {
            title: 'Yêu Cầu Tìm Trọ',
            total: 'Tổng yêu cầu',
          },
          visitingBookings: {
            title: 'Lịch Xem Nhà',
            total: 'Lịch hẹn',
          },
          noData: 'Chưa có dữ liệu',
        },
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'vi',
  fallbackLng: 'vi',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;